import { createActionConst } from '../../../../utils/action.utils';

const MEETING_ARCHIVE_NAMESPACE = 'MEETING_ARCHIVE';

export const INITIAL_ARCHIVE_PAGE = createActionConst(MEETING_ARCHIVE_NAMESPACE, 'INITIAL_ARCHIVE_PAGE');
export const FETCH_MEETING_ARCHIVE = createActionConst(MEETING_ARCHIVE_NAMESPACE, 'FETCH_MEETING_ARCHIVE');

export const STORE_MEETING_ARCHIVE_IDS = createActionConst(MEETING_ARCHIVE_NAMESPACE, 'STORE_MEETING_ARCHIVE_IDS');
export const CLEAR_MEETING_ARCHIVE_IDS = createActionConst(MEETING_ARCHIVE_NAMESPACE, 'CLEAR_MEETING_ARCHIVE_IDS');

export const STORE_MEETING_ARCHIVE_CURRENT_PAGE = createActionConst(
  MEETING_ARCHIVE_NAMESPACE,
  'STORE_MEETING_ARCHIVE_CURRENT_PAGE',
);
export const CLEAR_MEETING_ARCHIVE_CURRENT_PAGE = createActionConst(
  MEETING_ARCHIVE_NAMESPACE,
  'CLEAR_MEETING_ARCHIVE_CURRENT_PAGE',
);

export const STORE_MEETING_ARCHIVE_TOTAL_PAGES = createActionConst(
  MEETING_ARCHIVE_NAMESPACE,
  'STORE_MEETING_ARCHIVE_TOTAL_PAGES',
);
export const CLEAR_MEETING_ARCHIVE_TOTAL_PAGES = createActionConst(
  MEETING_ARCHIVE_NAMESPACE,
  'CLEAR_MEETING_ARCHIVE_TOTAL_PAGES',
);
